// extracted by mini-css-extract-plugin
export default {"supportIconButton":"UploadAppearance_supportIconButton__6No3o","sectionDivider":"UploadAppearance_sectionDivider__DFS9J"};